import dynamic from 'next/dynamic';
import React from 'react';
const MicroBusinesses = dynamic(() => import('@/components/MicroBusinesses'), {
  ssr: false,
});

const MicroBusinessesPage = () => {
  return <MicroBusinesses />;
};

export default MicroBusinessesPage;
